import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/button/Button.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/wrapper/Wrapper.module.scss")